import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { auth } from '@/utils/auth'

export function useAutoLogout(timeoutMinutes = 15) {
  const router = useRouter()
  let timeoutId = null

  const resetTimer = () => {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(logout, timeoutMinutes * 60 * 1000)
  }

  const logout = async () => {
    await auth.signOut()
    router.push({ path: '/login', query: { timeout: 'true' } })
  }

  const setupActivityListeners = () => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
    events.forEach(event => document.addEventListener(event, resetTimer))
    resetTimer()

    return () => {
      events.forEach(event => document.removeEventListener(event, resetTimer))
      if (timeoutId) clearTimeout(timeoutId)
    }
  }

  onMounted(() => {
    const cleanup = setupActivityListeners()
    onUnmounted(cleanup)
  })
}
